import { useI18n } from "@/app/composables/useI18n"
import { useLogoBanner } from "@/app/composables/useLogoBanner"
import { computed } from "vue"

export function useBannerTranslation() {
  const { locale } = useI18n()

  const getBannerImage = computed(() => {
    return (banner: any) => {
      if (!banner || !banner.translations)
        return null

      const currentLangCode = locale.value?.code

      if (currentLangCode && banner.translations[currentLangCode] && banner.translations[currentLangCode].image) {
        return banner.translations[currentLangCode].image
      }

      if (banner.translations.en && banner.translations.en.image) {
        return banner.translations.en.image
      }

      return null
    }
  })

  const getLogoImage = computed(() => {
    return (logo: any) => {
      if (!logo || !logo.translations)
        return null

      const currentLangCode = locale.value?.code

      if (currentLangCode && logo.translations[currentLangCode] && logo.translations[currentLangCode].image) {
        return logo.translations[currentLangCode].image
      }

      if (logo.translations.en && logo.translations.en.image) {
        return logo.translations.en.image
      }

      return null
    }
  })

  const getPromoBannerImage = computed(() => {
    return (promoBanner: any) => {
      if (!promoBanner || !promoBanner.translations)
        return null

      const currentLangCode = locale.value?.code

      if (currentLangCode && promoBanner.translations[currentLangCode] && promoBanner.translations[currentLangCode].image) {
        return promoBanner.translations[currentLangCode].image
      }

      if (promoBanner.translations.en && promoBanner.translations.en.image) {
        return promoBanner.translations.en.image
      }

      return null
    }
  })

  return {
    getBannerImage,
    getLogoImage,
    getPromoBannerImage,
  }
}

export function useTranslatedLogo() {
  const { logo } = useLogoBanner()
  const { getLogoImage } = useBannerTranslation()

  const translatedLogo = computed(() => {
    const translatedUrl = getLogoImage.value(logo.value)
    return translatedUrl?.url || logo.value?.image?.url || null
  })

  return {
    logo: translatedLogo,
  }
}

export function useTranslatedPromoBanner() {
  const { promoBanner } = useLogoBanner()
  const { getPromoBannerImage } = useBannerTranslation()

  const translatedPromoBanner = computed(() => {
    const translatedImage = getPromoBannerImage.value(promoBanner.value)
    return {
      ...promoBanner.value,
      image: { url: translatedImage?.url || promoBanner.value?.image?.url },
    }
  })

  return {
    promoBanner: translatedPromoBanner,
  }
}
